import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { posible_bg, posible_logo } from "../config/imageImport";
import { toast } from "react-toastify";
import Input from "../components/controls/Input";
import Button from "../components/controls/Button";
import Icon from "../assets/icons/Icon";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";
import { isMobileView } from "../components/controls/CommonFunctions";

const ForgotPassword = () => {
  const [loginId, setLoginId] = useState("");
  const [loading, setLoading] = useState(false);
const [loginIDError,setLoginIDError]=useState("");
    

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if(!loginId){
      setLoginIDError("Login ID is required");
      return;
    }
    setLoading(true);

    try {
  await sendPasswordResetEmail(auth, loginId);
  toast.success("Password reset email sent successfully! Check your inbox.");
} catch (error) {
  toast.error(error.message || "Failed to send reset email");
}
        finally{
          setLoading(false);
        }
  
  };

  return (
       <div className={`${isMobileView() ? "h-[100dvh] px-6" : "min-h-screen py-12"} flex items-center justify-center   lg:px-8 relative overflow-hidden primary-gradient`}>
      {!isMobileView() && <><div className="absolute w-[300px] h-[300px] rounded-full bg-white/10 top-[10%] left-[10%] animate-[float_8s_infinite_ease-in-out] z-100"></div>
        <div className="absolute w-[200px] h-[200px] rounded-full bg-white/10 bottom-[20%] right-[15%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[2s]"></div>
        <div className="absolute w-[150px] h-[150px] rounded-full bg-white/10 bottom-[10%] left-[20%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[4s]"></div>
      </>}
      <div className=" p-4 py-17  flex flex-col gap-5  w-100 px-5 rounded-2xl backdrop-blur-sm bg-[rgba(255,255,255,0.85)] shadow-[0_15px_35px_rgba(0,0,0,0.2)]">
        <img src={posible_logo} alt="posible logo" className="w-54 mx-auto" />

        <form onSubmit={handleForgotPassword} className="flex flex-col gap-8">
          <Input
            label="Login ID"
            type="text"
            placeholder="Enter your login ID"
            value={loginId}
            onChange={(e) => {setLoginId(e.target.value),setLoginIDError("")}}
            errorMessage={loginIDError}
            starttext={
              <span className="w-5">
                <Icon type="email" />
              </span>
            }
          />

          <Button submit="true" type="primary" loading={loading}>
            Reset Paasword
          </Button>
        </form>
        <Link
          to="/home"
          className=" text-[#6e2d90] font-normal hover:underline mx-auto"
        >
         Already an existing user? Sign In
        </Link>
      </div>

      <style>{`
    @keyframes float {
      0% { transform: translateY(0px) rotate(0deg); }
      50% { transform: translateY(-20px) rotate(5deg); }
      100% { transform: translateY(0px) rotate(0deg); }
    }
    .animation-delay-2000 {
      animation-delay: 2s;
    }
    .animation-delay-4000 {
      animation-delay: 4s;
    }
  `}</style>
    </div>
   
  );
};

export default ForgotPassword;
